import { Card, CardBody, Table } from "reactstrap";
import { ECommerce, Invoice } from "../../../../../constants";
import { InvoiceButtons } from "../common/InvoiceButtons";
import { InvoiceAddressSection } from "./InvoiceAddressSection";
import { InvoiceDateSection } from "./InvoiceDateSection";
import { InvoiceHeadSection } from "./InvoiceHeadSection";
import { InvoiceTable } from "./InvoiceTable";
import { InvoiceTaxSection } from "./InvoiceTaxSection";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

// This component renders an invoice layout with sections for header, date, address, table, tax, and action buttons.
const Invoice2Container = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Invoice} parent={ECommerce} />
      <div className="invoice-2">
        <Card>
          <CardBody>
            <Table borderless>
              <tbody>
                <tr>
                  <InvoiceHeadSection />
                </tr>
                <tr>
                  <InvoiceDateSection />
                </tr>
                <tr>
                  <InvoiceAddressSection />
                </tr>
                <tr>
                  <InvoiceTable />
                </tr>
                <tr>
                  <InvoiceTaxSection />
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>
      <InvoiceButtons />
    </>
  );
};

export default Invoice2Container;
